import React, { useState } from "react";
import "./FiltersSidebar.scss";

const FILTERS = {
  Experts: ["Expert 1", "Expert 2"],
  "Recommendation Type": ["Short Term", "Long Term"],
  "Recommendation Status": [
    "Live",
    "Updated",
    "Yet To Live",
    "Target Achieved",
    "Target Not Achieved",
    "Stop Loss Triggered",
    "Exit",
    "Expired",
  ],
  "Target Period": ["1 Week", "1 Month", "3 Months"],
};

export default function FiltersSidebar({
  isPopup = false,
  onClose,
  selectedFilters,
  setSelectedFilters,
}) {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const toggleFilter = (value) => {
    setSelectedFilters((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const removeFilter = (value) => {
    setSelectedFilters((prev) => prev.filter((item) => item !== value));
  };

  const resetAll = () => {
    setSelectedFilters([]);
    setOpenSection(null);
  };

  return (
    <aside className={`sidebar ${isPopup ? "popup-mode" : ""}`}>
      {/* HEADER */}
      <div className="sidebar-header">
        <h5>Filters ({selectedFilters.length})</h5>

        <div className="header-actions">
          <button className="reset-btn" onClick={resetAll}>
            Reset all
          </button>

          {isPopup && (
            <button className="close-btn" onClick={onClose}>
              ✕
            </button>
          )}
        </div>
      </div>

      {/* ACTIVE FILTER CHIPS */}
      <div className="active-filters">
        {selectedFilters.map((tag) => (
          <span key={tag} className="filter-chip">
            {tag}
            <span className="chip-close" onClick={() => removeFilter(tag)}>
              ×
            </span>
          </span>
        ))}
      </div>

      {/* FILTER SECTIONS */}
      {Object.keys(FILTERS).map((section) => {
        const count = selectedFilters.filter((f) =>
          FILTERS[section].includes(f)
        ).length;

        return (
          <div key={section}>
            <div className="filter-row" onClick={() => toggleSection(section)}>
              <span>
                {section}
                {count > 0 && <span className="count"> ({count})</span>}
              </span>
              <span className="plus">
                {openSection === section ? "−" : "+"}
              </span>
            </div>

            {openSection === section && (
              <div className="options">
                {FILTERS[section].map((option) => (
                  <label key={option} className="option-item">
                    <input
                      type="checkbox"
                      checked={selectedFilters.includes(option)}
                      onChange={() => toggleFilter(option)}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </aside>
  );
}
